import { render, staticRenderFns } from "./MediaCenter.vue?vue&type=template&id=8c1e4578&scoped=true&"
import script from "./MediaCenter.vue?vue&type=script&lang=js&"
export * from "./MediaCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1e4578",
  null
  
)

export default component.exports